// Replace your client-side Firestore call with this:
const storePendingOrder = async (
  basket,
  shippingInfo,
  orderId,
  currency,
  currencySymbol
) => {
  await fetch(
    `${process.env.REACT_APP_API_URL}/api/orders/store-pending-order`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        basket,
        shippingInfo,
        orderId,
        currency,
        currencySymbol,
      }),
    }
  );
};

// Get pending order from backend
const getPendingOrder = async (orderId) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/orders/pending-order/${orderId}`
  );
  if (response.ok) {
    return await response.json();
  } else {
    return null;
  }
};

// Confirm payment on backend
const confirmPayment = async (orderId, paymentIntent) => {
  await fetch(`${process.env.REACT_APP_API_URL}/api/payments/confirm-payment`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderId, paymentIntent }),
  });
};

const getCardDetails = async (paymentIntentId) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/payments/get-card-details`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ paymentIntentId }),
    }
  );
  const data = await response.json();
  return data;
};

const getStockDetails = async (products) => {
  // products should be an array: [{ productUid, region }, ...]
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/products/stock-check`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ products }),
    }
  );
  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    return null;
  }
};

export {
  storePendingOrder,
  confirmPayment,
  getPendingOrder,
  getCardDetails,
  getStockDetails,
};
